import React from "react";
import "../css/navbar.css";

const TopBanner = () => {
  return (
    <div className="top-banner">
      <div className="top-banner-left">
        <div className="phone">
          <i class="fa-solid fa-phone"></i>
             <a
            href="tel:+91 8745000242"
            target="_blank"
            aria-label="mail us for hotel booking"
          >
           +91 8745000242
          </a>

           <a
            href="tel:+91 99718 34101"
            target="_blank"
            aria-label="mail us for hotel booking"
          >
           +91 99718 34101
          </a>
        </div>
        <div className="email">
          <i class="fa-solid fa-envelope"></i>
          <a
            href="mailto:welcome@mpholidays.online"
            target="_blank"
            aria-label="mail us for hotel booking"
          >
            welcome@mpholidays.online
          </a>
        </div>
      </div>

      <div className="top-banner-right">
        <a
          href="#"
          target="_blank"
          aria-label="follow us on instagram"
        >
          <i class="fa-brands fa-instagram"></i>
        </a>
        <a
          href="https://www.facebook.com/MPHOLIDAYSPVTLTD"
          target="_blank"
          aria-label="follow us on facebook"
        >
          <i class="fa-brands fa-facebook"></i>
        </a>
        <a
          href="#"
          target="_blank"
          aria-label="follow us on twitter"
        >
          <i class="fa-brands fa-twitter"></i>
        </a>
      </div>
    </div>
  );
};

export default TopBanner;
